import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Réserve l'espace admin aux ROLE_ADMIN. À chaîner APRÈS authGuard sur la route
 * (`canActivate: [authGuard, adminGuard]`) : authGuard gère déjà back injoignable /
 * non authentifié / non approuvé. Le back reste l'autorité (403 sinon).
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAdmin() ? true : router.createUrlTree(['/']);
};
